var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sms-page-container"},[_c('EcsWindowManager',{attrs:{"interactions":_vm.interactions,"minimized-windows-right-offset":96}}),_c('EcsCreateSms',{attrs:{"hidden":_vm.hideDialpadFab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }